import {useCallback} from 'react'
import {useSelector} from 'react-redux'
import {selectCombinedStaffLookup} from '../../reducers/selectors'
import {createGetStaff} from './useStaffLookup'

/**
 * Similar to useStaffLookup but uses combined data from both the active building
 * and sister buildings. Use this hook in amenities and events features where
 * staff from sister buildings may manage shared amenities.
 */
function useCombinedStaffLookup() {
  const staffLookup = useSelector(selectCombinedStaffLookup)

  const getStaff = useCallback(createGetStaff(staffLookup), [staffLookup])

  return {getStaff}
}

export default useCombinedStaffLookup
